export default __webpack_public_path__ + "static/media/TF3-2.3c90ab1b.jpg";